
var _storageProvider = window.localStorage;

function setItem(key,value) {
  _storageProvider.setItem(key,value);
}

function getItem(key) {
  return _storageProvider.getItem(key);
}

function removeItem(key) {
  _storageProvider.removeItem(key);
}

export default {
  setItem: setItem,
  getItem: getItem,
  removeItem : removeItem
}
